import { RpsiFluxDto, SearchFluxRpsiResponseDto } from 'lib_api/lib/api/gen';

import {
  FetchDataResult,
  TablePagination,
  TableSort,
} from 'components/WrappedComponents/Table/types';
import { useApi } from 'hooks/ApiStoreContext';

import { FilterDashboardFlux } from '../types';

import { FluxRpsiSortOptions } from './types';

export function useSearchFluxRpsi(
  filters: FilterDashboardFlux,
  sorts: TableSort<FluxRpsiSortOptions>,
  pagination: TablePagination,
): [
  () => Promise<SearchFluxRpsiResponseDto>,
  (result: SearchFluxRpsiResponseDto) => FetchDataResult<RpsiFluxDto>,
] {
  const controller = useApi().AdminFonctionnelControllerApi;

  return [
    () => {
      return controller.searchFluxRpsiUsingGET({
        sortDto: {
          dateAppel: sorts?.DATE_APPEL,
        },
        page: pagination.page - 1,
        pageSize: pagination.pageSize,
      });
    },
    result => {
      return {
        data: result.flux,
        total: result.total,
      };
    },
  ];
}
